var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPartial(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.382812,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#DAE9FE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2345 15.4001H10.0843C9.92519 15.4001 9.7726 15.4633 9.66009 15.5758C9.54758 15.6883 9.48438 15.8409 9.48438 16C9.48438 16.1591 9.54758 16.3117 9.66009 16.4242C9.7726 16.5367 9.92519 16.5999 10.0843 16.5999H21.2345L16.8586 20.9746C16.746 21.0872 16.6827 21.24 16.6827 21.3993C16.6827 21.5586 16.746 21.7114 16.8586 21.8241C16.9713 21.9367 17.1241 22 17.2834 22C17.4427 22 17.5955 21.9367 17.7081 21.8241L23.1075 16.4247C23.1633 16.369 23.2076 16.3028 23.2379 16.2299C23.2681 16.157 23.2837 16.0789 23.2837 16C23.2837 15.9211 23.2681 15.843 23.2379 15.7701C23.2076 15.6972 23.1633 15.631 23.1075 15.5753L17.7081 10.1759C17.5955 10.0633 17.4427 10 17.2834 10C17.1241 10 16.9713 10.0633 16.8586 10.1759C16.746 10.2886 16.6827 10.4414 16.6827 10.6007C16.6827 10.76 16.746 10.9128 16.8586 11.0254L21.2345 15.4001Z",
    fill: "#2F405A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartial);
export default __webpack_public_path__ + "static/media/partial.d58077276f1201591a1930fd9862cd00.svg";
export { ForwardRef as ReactComponent };